import type { BranchDeliverySettingMiniEntity } from '@/features/branchDeliverySetting/domain/entities/BranchDeliverySettingMiniEntity'
import type { PaymentType } from '@/features/orderPaymentType/domain/enums/PaymentType'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class ServiceMiniEntity {
  id?: number
  name?: string
  region?: RegionMiniEntity
  regionName?: string | null
  latitude?: number | null
  longitude?: number | null
  serviceFee?: number
  packageServiceFee?: number
  minimumCartAmountToOrder?: number
  createdAt?: string
  walletUserId?: string
  disabled?: boolean
  feePerDistance?: number
  pouchDefaultMaxAmountLimit?: number
  largeOrderThreshold?: number
  autoOrderApprovalPriceLimit?: number
  taxRatioPerOrder?: number | null
  commissionAmountPerOrder?: number | null
  targetDriverDeliveryTime?: number
  targetDriverActiveTime?: number
  allowDriverToUpdateOrderWithinRadiusInMeter?: number | null
  orderPaymentTypes?: Array<PaymentType> | null
  allowClientCancelOrderWithinInSecond?: number | null
  zohoBooksBranchId?: string | null
  isScheduledOrderSupported?: boolean
  commissionAmountPerJetOrder?: number | null
  deliverySystems?: Array<BranchDeliverySettingMiniEntity> | null
  scheduleOrderApprovalMinutes?: number | null
  orderExpensiveLimit?: number | null
  supportedPackageCargoVehicleTypes?: Array<VehicleTemplateType> | null
  automaticReachDestinationDistance?: number
  automaticReachBranchDistance?: number
  disableAutomaticDriverReach?: boolean
}
